module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px",
      "height": "100%"
    }
  }, [_c('ul', {
    attrs: {
      "id": "water-data"
    }
  }, _vm._l((_vm.waterData), function(items, index) {
    return _c('li', {
      key: items[index],
      style: (_vm.liStyle(index))
    }, [_c('p', [_c('span', {
      class: index == 0 ? 'iconfont icon-droplet' : 'iconfont icon-stats-bars2',
      staticStyle: {
        "font-size": "20px",
        "color": "white"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(index == 0 ? '抄见数据' : '用水统计'))])]), _vm._v(" "), _vm._l((items), function(content) {
      return _c('p', {
        key: content.id,
        attrs: {
          "id": content.id
        }
      }, [_c('span', [_vm._v(_vm._s(content.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(content.data))])])
    })], 2)
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dataChart"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a4e86aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/waterStatisticsSummary.vue
// module id = 1784
// module chunks = 1